import React from "react";
import PageContainer from "../components/PageContainer/PageContainer";
import { getUserInfo } from "../ApiService";
import { useQuery } from "react-query";
import PageBlock from "../components/PageContainer/PageBlock";

export default function LkPage() {
  const { data: userInfo } = useQuery("userInfo", getUserInfo);
  return (
    <PageContainer>
      <PageBlock>
        <h3 className="h3Font">Личный кабинет</h3>
        <h1> {userInfo?.name}</h1>
        <h1> {userInfo?.email}</h1>
        <h1> Баланс токенов: {userInfo?.tokenBalance}</h1>
      </PageBlock>
    </PageContainer>
  );
}
